import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ChatStatus } from '../../models/chat';

@Component({
  selector: 'pm-chat-status',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (label()) {
      <div
        class="flex items-center gap-2 text-sm leading-[1.3] text-content-subdued"
        role="status"
        aria-live="polite"
      >
        <span class="inline-flex items-center gap-[3px]" aria-hidden="true">
          <span
            class="h-[3px] w-[3px] rounded-full bg-content-subdued animate-pulse motion-reduce:animate-none"
          ></span>
          <span
            class="h-[3px] w-[3px] rounded-full bg-content-subdued animate-pulse [animation-delay:.2s] motion-reduce:animate-none"
          ></span>
          <span
            class="h-[3px] w-[3px] rounded-full bg-content-subdued animate-pulse [animation-delay:.4s] motion-reduce:animate-none"
          ></span>
        </span>
        <span>{{ label()! | translate }}</span>
      </div>
    }
  `,
  imports: [TranslatePipe],
})
export class ChatStatusComponent {
  readonly status = input.required<ChatStatus>();

  protected readonly label = computed(() => {
    switch (this.status()) {
      case ChatStatus.Working:
        return 'chat.status.thinking';
      case ChatStatus.Thinking:
        return 'chat.status.thinking';
      case ChatStatus.Searching:
        return 'chat.status.searching';
      default:
        return null;
    }
  });
}
